import script from "./FAQsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQsPage.vue?vue&type=script&setup=true&lang=js"

import "./FAQsPage.vue?vue&type=style&index=0&id=5b48ea40&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b48ea40"]])

export default __exports__